<!-- Um único popup, com model estável, serve todas as linhas. -->
<p-menu
  #actionsMenu
  [model]="menuItems"
  [popup]="true"
  appendTo="body"
></p-menu>

<div class="data-table-wrapper">
  <table class="data-table efetivos-table">
    <colgroup>
      <col class="col-nome" />
      <col class="col-mec" />
      <col class="col-funcao" />
      <col class="col-categoria" />
      <col class="col-telefone" />
      <col class="col-estado" />
      <col class="col-admissao" />
      <col class="col-acoes" />
    </colgroup>
    <thead>
      <tr>
        <th class="col-nome">Nome</th>
        <th class="col-mec">MEC</th>
        <th class="col-funcao">Função</th>
        <th class="col-categoria">Categoria</th>
        <th class="col-telefone">Telefone</th>
        <th class="col-estado">Estado</th>
        <th class="col-admissao">Admissão</th>
        <th class="col-acoes">Ações</th>
      </tr>
    </thead>

    <tbody>
      <!-- Skeleton rows enquanto carrega -->
      <ng-container *ngIf="skeletonLoading">
        <tr *ngFor="let _ of skeletonRows">
          <td colspan="8">
            <p-skeleton height="2rem"></p-skeleton>
          </td>
        </tr>
      </ng-container>

      <!-- Sem resultados -->
      <tr *ngIf=" !skeletonLoading && (!pagination?.data || pagination.data.length === 0)">
        <td colspan="8" class="empty-state">
          <div class="empty-state-content">
            <i class="pi pi-users"></i>
            <span>Nenhum efetivo encontrado</span>
          </div>
        </td>
      </tr>

      <!-- Dados reais -->
      <ng-container *ngIf="!skeletonLoading">
        <tr *ngFor="let efetivo of pagination?.data">
          <!-- Coluna Nome -->
          <td class="col-nome">
            <div class="table-user">
              <div
                class="table-avatar"
                [ngClass]="getAvatarColor(efetivo.id)"
                [style.backgroundImage]="
                  fotoPreviewMap[efetivo.id]
                    ? 'url(' + fotoPreviewMap[efetivo.id] + ')'
                    : null
                "
                [style.backgroundSize]="
                  fotoPreviewMap[efetivo.id] ? 'cover' : null
                "
                [style.backgroundPosition]="
                  fotoPreviewMap[efetivo.id] ? 'center' : null
                "
              >
                <span *ngIf="!fotoPreviewMap[efetivo.id]">
                  {{ getInitials(efetivo.nome) }}
                </span>
              </div>

              <div class="table-user-details">
                <strong>{{ efetivo.nome }}</strong>
                <small>{{ efetivo.numBI || "—" }}</small>
              </div>
            </div>
          </td>

          <!-- Coluna MEC -->
          <td class="col-mec">
            <span *ngIf="efetivo.codigoMec; else noMec">
              {{ efetivo.codigoMec }}
            </span>
            <ng-template #noMec>
              <span class="text-muted">—</span>
            </ng-template>
          </td>

          <!-- Coluna Função -->
          <td class="col-funcao">{{ efetivo.nomeFuncao || "—" }}</td>

          <!-- Coluna Categoria -->
          <td class="col-categoria">{{ efetivo.nomeCategoria || "—" }}</td>

          <!-- Coluna Telefone -->
          <td class="col-telefone">{{ efetivo.numTelefone || "—" }}</td>

          <!-- Coluna Estado -->
          <td class="col-estado">
            <ng-container
              *ngIf="getEstadoBadge(efetivo.estadoEfetivo) as estadoBadge"
            >
              <span class="badge" [ngClass]="estadoBadge.classe">
                <i [class]="estadoBadge.icon"></i>
                {{ estadoBadge.label }}
              </span>
            </ng-container>
          </td>

          <!-- Coluna Admissão -->
          <td class="col-admissao">
            {{
              efetivo.dataAdmissao
                ? (efetivo.dataAdmissao | date: "dd/MM/yyyy")
                : "—"
            }}
          </td>

          <!-- Coluna Ações -->
          <td class="col-acoes">
            <button
              type="button"
              class="btn-dots"
              title="Opções"
              aria-label="Abrir ações do efetivo"
              (click)="openActions($event, efetivo, actionsMenu)"
            >
              <i class="pi pi-ellipsis-v"></i>
            </button>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<!-- Paginação padronizada -->
<app-paginator-control
  *ngIf="!skeletonLoading"
  [alwaysShow]="true"
  [rows]="pagination?.pageSize ?? 10"
  [totalRecords]="pagination?.totalRecords ?? 0"
  [rowsPerPageOptions]="[10, 20, 50]"
  [first]="((pagination?.pageNumber ?? 1) - 1) * (pagination?.pageSize ?? 10)"
  (pageChange)="onPageChange($event)"
/>
